var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckAlertGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "09C832A1-5119-49F3-9C8C-00F269A95636") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 1424,
    height: 496,
    rx: 10
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.9%",
    y: "-3.0%",
    width: "103.8%",
    height: "110.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 12,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.04 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Consultant",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Timesheet-Copy-4",
    transform: "translate(-395.000000, -1618.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F8F8FA",
    x: 0,
    y: 0,
    width: 1680,
    height: 2039
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(156.000000, 1466.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bg"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Check",
    transform: "translate(239.000000, 152.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#1D9900",
    cx: 7,
    cy: 7,
    r: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2934462,3.65817207 C11.6660515,3.91899578 11.773256,4.4176284 11.5535379,4.80544723 L11.5084946,4.87677955 L7.42516126,10.7101129 L7.4081551,10.7335843 C7.40276144,10.7407622 7.39724102,10.7478822 7.39159354,10.7549415 L7.36763445,10.7799249 L7.35052896,10.8028015 C7.34451671,10.8093129 7.33842147,10.8157156 7.33224602,10.8220092 L7.39159354,10.7549415 C7.35943267,10.7951426 7.32444864,10.8317553 7.28715172,10.8647228 C7.27302125,10.8772748 7.25864829,10.8891577 7.2439642,10.9005277 C7.22737908,10.9133596 7.20998354,10.9258496 7.19222659,10.9376374 C7.1772656,10.9475509 7.16224931,10.9568532 7.14699987,10.9656728 C7.13117547,10.9748652 7.11501785,10.9835465 7.0986422,10.9916925 C7.07930463,11.0012596 7.05959206,11.0101617 7.03960908,11.0183127 C7.02350373,11.0249351 7.0073985,11.0309512 6.99115109,11.0364826 C6.97306162,11.0426007 6.95440926,11.0482766 6.93559949,11.0533252 C6.91823498,11.0580105 6.9011506,11.0620366 6.88397,11.0655472 C6.862727,11.0698922 6.84067628,11.0735553 6.81851062,11.0763754 C6.8029937,11.0783282 6.78796399,11.0798335 6.77290288,11.0809514 C6.75064108,11.0826459 6.72786933,11.0834699 6.70506963,11.0834049 C6.68954478,11.0833161 6.67386867,11.0828515 6.65820282,11.081966 C6.63886029,11.0809198 6.61980565,11.0792128 6.60078971,11.0768748 C6.58119978,11.07442 6.56148516,11.071317 6.54185867,11.0675315 C6.52377,11.0640795 6.50570604,11.0599925 6.4877362,11.0553148 C6.46949278,11.0505572 6.45119554,11.0451624 6.43303858,11.0391484 C6.41160494,11.0320232 6.39054156,11.0241169 6.36970252,11.0153487 C6.35486045,11.0091565 6.34021467,11.0025201 6.32570855,10.995452 C6.30879166,10.9871429 6.2917192,10.9781222 6.27485853,10.9684813 C6.26101733,10.9606391 6.24763064,10.9524957 6.23440663,10.9439535 L6.21824047,10.9332044 C6.21433078,10.9305592 6.21043509,10.9278782 6.20655378,10.9251613 L6.18163445,10.9059249 L6.16172517,10.8915935 L3.2450585,8.55826021 C2.86770431,8.25637685 2.8065231,7.70574603 3.10840646,7.32839183 C3.3914221,6.97462228 3.89306346,6.89873914 4.26559337,7.13937988 L4.33827483,7.19173979 L6.52563445,8.94192487 L10.0748387,3.87322045 C10.3519639,3.47732731 10.8975531,3.38104688 11.2934462,3.65817207 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckAlertGreen);
export default __webpack_public_path__ + "static/media/check-alert-green.552489f14d19713aa43f11a1c0221fa9.svg";
export { ForwardRef as ReactComponent };